import {
    CHECK_PRODUCT_BOM,
    CHECK_PRODUCT_BOM_SUCCESS,
    CHECK_PRODUCT_BOM_FAILURE,
    RESET_BOM_DATA,
    DELETE_PRODUCT_BOM,
} from '../actions/actionTypes';

const initialState = {
    productBomDetails: [],
    statusCode: '',
    statusMessage: '',
    productBomDetailsLoading: false,
};

const updateProductBOMDetails = (cfn, currentDetails) => {
    return (currentDetails || []).filter((item) => item.prodcutCFN !== cfn);
};

const checkProductBomReducer = (state = initialState, action) => {
    switch (action.type) {
        case RESET_BOM_DATA:
            return { ...state, ...initialState };
        case CHECK_PRODUCT_BOM:
            return {
                ...state,
                productBomDetails: [...state.productBomDetails],
                statusCode: '',
                statusMessage: '',
                productBomDetailsLoading: true,
            };
        case CHECK_PRODUCT_BOM_SUCCESS: {
            if (action.payload.isFromCart) {
                // If the action is from cart, we reset the productBomDetails
                return {
                    ...state,
                    productBomDetails: action.payload.productBOMDataDTO || [],
                    statusCode: action.payload?.statusCode || '',
                    statusMessage: action.payload.statusMessage || '',
                    productBomDetailsLoading: false,
                };
            }
            // Create a map of current details by productCFN
            const currentMap = new Map(
                (state.productBomDetails || []).map((item) => [
                    item.prodcutCFN,
                    item,
                ])
            );
            // Update or add new details from payload
            (action.payload.productBOMDataDTO || []).forEach((newItem) => {
                currentMap.set(newItem.prodcutCFN, newItem);
            });
            return {
                ...state,
                productBomDetails: Array.from(currentMap.values()),
                statusCode: action.payload?.statusCode || '',
                statusMessage: action.payload.statusMessage || '',
                productBomDetailsLoading: false,
            };
        }
        case CHECK_PRODUCT_BOM_FAILURE:
            return {
                ...state,
                productBomDetails: [...state.productBomDetails],
                statusCode: action.payload?.statusCode,
                statusMessage: action.payload.statusMessage,
                productBomDetailsLoading: false,
            };
        case DELETE_PRODUCT_BOM:
            return {
                ...state,
                productBomDetails: updateProductBOMDetails(
                    action.payload,
                    state.productBomDetails
                ),
            };
        default: {
            return { ...state };
        }
    }
};

export default checkProductBomReducer;
